import { PageHeaderButton } from '@vtex/admin-ui'
import { useNavigation } from '@vtex/raccoon-next'
import { useFeature } from 'hooks'
import { FormattedMessage } from 'react-intl'
import { scrollToFirstError } from 'shared'
import { Event } from 'typings'
import { useFormStateContext } from 'ui'
import { useAnalytics } from 'use-analytics'
import { Promotion } from '../../typings'
import { CreateTemplateButton } from '../Template/CreationModal'

const messages = {
  new: {
    cancel: { id: 'admin/promotions.utils.discard' },
    save: { id: 'admin/promotions.utils.create' },
  },
  edit: {
    cancel: { id: 'admin/promotions.utils.cancel' },
    save: { id: 'admin/promotions.utils.save' },
  },
}

export function ActivePromotionHeaderButtons() {
  const { originalValues, form } = useFormStateContext()
  const { isSubmitting } = form.formState

  const { navigate } = useNavigation()

  const { track } = useAnalytics()

  const { getFeature } = useFeature()
  const enableTemplate = getFeature('template')

  const isNew = !originalValues

  const buttonMessages = isNew ? messages.new : messages.edit

  const handleCancel = () => {
    const promotion: Promotion = form.getValues()

    track(Event.PROMOTION_DISCARD_CLICK, { isNew, type: promotion.type })
    navigate('/')
  }

  const handleSubmit = async () => {
    const valid = await form.trigger()

    if (!valid) {
      scrollToFirstError({ behavior: 'auto' })
      return
    }
  }

  return (
    <>
      {enableTemplate && <CreateTemplateButton />}
      <PageHeaderButton variant="tertiary" onClick={handleCancel}>
        <FormattedMessage {...buttonMessages.cancel} />
      </PageHeaderButton>
      <PageHeaderButton
        type="submit"
        onClick={handleSubmit}
        loading={isSubmitting}
      >
        <FormattedMessage {...buttonMessages.save} />
      </PageHeaderButton>
    </>
  )
}
